import { render } from "./TakeAssetsProposals.vue?vue&type=template&id=6c1c48ba&scoped=true&ts=true"
import script from "./TakeAssetsProposals.vue?vue&type=script&lang=ts"
export * from "./TakeAssetsProposals.vue?vue&type=script&lang=ts"

import "./TakeAssetsProposals.vue?vue&type=style&index=0&id=6c1c48ba&lang=scss&scoped=true"

import exportComponent from "C:\\ProjectsLaravel\\nft_imw_v2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c1c48ba"],['__file',"resources/ts/frontend/components/TakeAssetsProposals.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6c1c48ba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c1c48ba', __exports__)) {
    console.log('reload')
    api.reload('6c1c48ba', __exports__)
  }
  
  module.hot.accept("./TakeAssetsProposals.vue?vue&type=template&id=6c1c48ba&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('6c1c48ba', render)
  })

}


export default __exports__